/* eslint-disable @typescript-eslint/quotes */
import baseContentForm from 'formiojs/components/button/Button.form';
import { defaultConditionalFields, defaultApiFields } from '#web-components/components/Form/constants';
import { ignoreBuilderFields } from '#web-components/components/Form/utils';
import { ButtonAction } from '#web-components/components/Form/types';

export default () => {
  return baseContentForm([
    {
      key: 'display',
      components: [
        {
          key: 'action',
          data: {
            values: [
              { label: 'Submit', value: ButtonAction.submit },
              { label: 'Custom', value: ButtonAction.custom },
              { label: 'Navigation', value: ButtonAction.navigation },
              { label: 'Save Data', value: ButtonAction.save },
            ],
          },
          overrideEditForm: true,
        },
        {
          type: 'textfield',
          key: 'actionCode',
          label: 'Action code',
          input: true,
          weight: 112,
          validate: {
            required: true,
          },
          conditional: {
            json: { '===': [{ var: 'data.action' }, 'navigation'] },
          },
        },
        {
          key: 'theme',
          data: {
            values: [
              { label: 'Primary', value: 'primary' },
              { label: 'Secondary', value: 'secondary' },
              { label: 'Cancel', value: 'cancel' },
            ],
          },
          overrideEditForm: true,
        },
        ...ignoreBuilderFields([
          'saveOnEnter',
          'size',
          'block',
          'leftIcon',
          'rightIcon',
          'shortcut',
          'customClass',
          'autofocus',
          'modalEdit',
          'tableView',
        ]),
      ],
    },
    {
      key: 'conditional',
      components: defaultConditionalFields,
    },
    {
      key: 'api',
      components: [
        ...ignoreBuilderFields(['tags', 'properties']),
        ...defaultApiFields,
      ],
    },
    {
      key: 'logic',
      ignore: true,
    },
    {
      key: 'layout',
      ignore: true,
    },
    {
      key: 'confirmation',
      label: 'Confirmation',
      components: [
        {
          type: 'checkbox',
          key: 'confirmationEnable',
          label: 'Pop-up should Display',
          input: true,
        },
        {
          type: 'textarea',
          key: 'confirmationDescription',
          label: 'Description',
          input: true,
          placeholder: 'Description for this field.',
          editor: 'ace',
          wysiwyg: {
            minLines: 3,
            isUseWorkerDisabled: true,
          },
          validate: {
            maxLength: 256,
            required: false,
          },
          conditional: {
            json: {
              '===': [
                {
                  var: 'data.confirmationEnable',
                },
                true,
              ],
            },
          },
          // eslint-disable-next-line max-len
          tooltip: 'The pop-up contains Confirm and Cancel buttons. Please when creating the notification be aware that the Confirm button is a navigation button while the Cancel button closes the pop-up and a user remains on the form. The maximum length of notification is 256 characters',
        },
      ],
    },
  ]);
};
